// src/components/ui/ActionsMenu.jsx
import React from 'react';
import { 
  Menu, 
  MenuItem, 
  ListItemIcon, 
  ListItemText,
  Divider 
} from '@mui/material';

/**
 * Reusable actions menu component
 * @param {Object} props
 * @param {HTMLElement|null} props.anchorEl - The anchor element for the menu
 * @param {boolean} props.open - Whether the menu is open or not
 * @param {Function} props.onClose - Function to close the menu
 * @param {Array} props.actions - Array of action objects
 * @param {boolean} props.hasDivider - Whether to show a divider
 * @param {Array} props.dangerActions - Array of dangerous action objects
 */
const ActionsMenu = ({
  anchorEl,
  open,
  onClose,
  actions = [],
  hasDivider = true,
  dangerActions = []
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {actions.map((action, index) => (
        <MenuItem 
          key={index} 
          onClick={() => {
            action.onClick();
            onClose();
          }}
          disabled={action.disabled}
        >
          {action.icon && (
            <ListItemIcon>
              {action.icon}
            </ListItemIcon>
          )}
          <ListItemText primary={action.label} />
        </MenuItem>
      ))}
      
      {hasDivider && dangerActions.length > 0 && <Divider />}
      
      {dangerActions.map((action, index) => (
        <MenuItem 
          key={index} 
          onClick={() => {
            action.onClick();
            onClose();
          }}
          disabled={action.disabled}
          sx={{ color: 'error.main' }}
        >
          {action.icon && (
            <ListItemIcon>
              {action.icon}
            </ListItemIcon>
          )}
          <ListItemText primary={action.label} />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ActionsMenu;
